import { useEffect, useState } from "react";
import style from './UserList.module.css';

const Users = ({ users, message, page }) => {
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 150;

  useEffect(() => {
    setFilteredUsers(users); 
  }, [users, page]);

  const handleInputvalue = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    if (searchTerm) {
      const filtered = users.filter(user =>
        user.phone.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredUsers(filtered);
      setCurrentPage(1);
    } else {
      setFilteredUsers(users);
    }
  };

  const handleExportToCSV = () => {
    const csvData = [
      ["Phone", "Registered"],
      ...filteredUsers.map(user => [user.phone, user.registered]),
    ];

    const csvContent = csvData
      .map(row => row.map(item => `"${item}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "users.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  const renderPagination = () => {
    const maxVisiblePages = 5; 
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    const pageNumbers = [];

    if (startPage > 1) {
      pageNumbers.push(1);
      if (startPage > 2) pageNumbers.push("..."); 
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) pageNumbers.push("..."); 
      pageNumbers.push(totalPages); 
    }

    return pageNumbers.map((page, index) =>
      typeof page === "number" ? (
        <button
          key={index}
          onClick={() => paginate(page)}
          className={currentPage === page ? "active" : ""}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-ellipsis">
          {page}
        </span>
      )
    );
  };

  return (
    <div className={style.subdiv}>
      <h2>User List</h2>
      {message && <p>{message}</p>}
      <div className="d-flex align-items-center">
        <input
          value={searchTerm}
          placeholder="Enter user phone"
          onChange={handleInputvalue}
          className="form-control m-3"
        />
        <button onClick={handleSearch} className="btn btn-secondary m-3">
          Search
        </button>
        <button onClick={handleExportToCSV} className="btn btn-secondary m-3">
          Export to CSV
        </button>
      </div>
      {currentUsers.length > 0 ? (
        <>
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Phone</th>
                <th scope="col">Registered</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers.map((user, index) => (
                <tr key={index}>
                  <td>{user.phone}</td>
                  <td>{user.registered}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="container">
            <div className="pagination">
              <button onClick={prevPage} disabled={currentPage === 1}>
                Previous
              </button>
              {renderPagination()}
              <button onClick={nextPage} disabled={currentPage === totalPages}>
                Next
              </button>
            </div>
          </div>
        </>
      ) : (
        <p>No users found.</p>
      )}
    </div>
  );
};

export default Users;
